module.exports = __webpack_public_path__ + "img/main4.98cc33e5.png";